module.exports = __webpack_public_path__ + "static/media/link.5dcf055f.png";